var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MicrohabitCategoriesPanelMenu", {
    attrs: { type: _vm.MICROHABIT_SIMPLE_TYPE },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function() {
          return [
            _c("h2", [
              _vm._v(_vm._s(_vm.$t("microhabits.simple.categories-menu.title")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "mt-3" }, [
              _vm._v(
                _vm._s(_vm.$t("microhabits.simple.categories-menu.subtitle"))
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0e25da86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e25da86","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/patient/microhabits/SimpleMicrohabitCategoriesPanelMenu.vue
// module id = 4190
// module chunks = 75